import { Radio as RadioComponent, RadioProps } from '@chakra-ui/radio';
import { forwardRef } from '@chakra-ui/system';
import * as React from 'react';
import { ChangeEvent } from 'react';

interface IDeprecatedRadioProps {
  /**
   * @deprecated use `RadioGroup.defaultValue` instead
   */
  defaultChecked?: boolean;

  /**
   * @deprecated use `RadioGroup.value` instead to control which radio is checked
   */
  isChecked?: boolean;

  /**
   * @deprecated use `RadioGroup.name` instead
   */
  name?: string;

  /**
   * @deprecated use `RadioGroup.size` instead to set same size for all radios within the group
   */
  size?: string;

  /**
   * @deprecated use `RadioGroup.onChange` instead
   */
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

type OmittedChakraRadioProps = keyof IDeprecatedRadioProps;

export interface IRadioProps
  extends Omit<RadioProps, OmittedChakraRadioProps | 'variant'>,
    IDeprecatedRadioProps {}

export const Radio = forwardRef<IRadioProps, 'div'>(({ ...rest }, ref) => {
  return <RadioComponent {...rest} ref={ref} />;
});
